import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, skipWhile, take } from 'rxjs';

import { LaunchDarklyService } from 'remarketing-angular-library';

@Injectable({
  providedIn: 'root'
})
export class DealerOnboardingGuard  {
  get isDealerOnboardingRegistrationEnabled() {
    return this.launchDarklyService.getFeatureFlag('dealer-onboarding-registrationEnabled', false);
  }

  constructor(
    private readonly launchDarklyService: LaunchDarklyService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    this.launchDarklyService.waitForLaunchDarkly()
      .pipe(skipWhile(ready => !ready), take(1)).subscribe(() => {
        if (!this.isDealerOnboardingRegistrationEnabled) {
          this.router.navigateByUrl('404');
        }
      });

    return of(true);
  }
}
